import UserExclusiveService from "../../services/user/userExclusiveService";

(() => {
    new UserExclusiveService();
})();